module.exports = __webpack_public_path__ + "static/media/171CO106.fbe142bb.jpg";